import { Stack, TextField, Typography } from "@mui/material";
import { useAppDispatch } from "../../../../Redux/hooks";
import { updateResponse } from "../../../../Redux/reducers/providerConsentSlice";
import DateField from "./DateField";

type Props = {
  currentBlock: any;
};

const InitialsField = ({ currentBlock }: Props) => {
  const dispatch = useAppDispatch();
  const label = currentBlock?.label;
  const config = currentBlock?.config;
  const position = config?.position;

  const response = currentBlock?.response;

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (currentBlock.editable)
      dispatch(
        updateResponse({
          blockId: currentBlock.id,
          key: "input",
          value: event.target.value,
        })
      );
  };

  return (
    <Stack gap={1} direction={position === "top" ? "column-reverse" : "column"}>
      <Typography variant="subtitle1" fontWeight="medium">
        {label}
      </Typography>
      {config?.type === "date" ? (
        <DateField
          dateFormat={config?.format}
          blockId={currentBlock.id}
          value={response?.input || ""}
          editable={currentBlock.editable}
        />
      ) : (
        <TextField
          sx={{
            width: {
              md: 350,
              xs: "100%",
            },
            maxWidth: "100%",
          }}
          placeholder="Enter Value"
          value={response?.input || ""}
          multiline={config?.allowMultiline}
          rows={config?.allowMultiline ? 2 : 1}
          onChange={handleChange}
        />
      )}
    </Stack>
  );
};
export default InitialsField;
